import get from 'lodash/get';

const TYPE_SLOW_2G = 'slow-2g';
const TYPE_2G = '2g';
const TYPE_3G = '3g';
const TYPE_4G = '4g';

const NETWORK_EFFECTIVE_TYPE_RATING = {
  [TYPE_SLOW_2G]: 0,
  [TYPE_2G]: 1,
  [TYPE_3G]: 2,
  [TYPE_4G]: 3,
};

const connection = __CLIENT__
  ? // @ts-expect-error non-standard Javascript API
    navigator.connection || navigator.mozConnection || navigator.webkitConnection
  : {};

export const getNetworkCondition = () => connection;

// currently only return as good connection for 4g
export const isGoodConnection = (): boolean => {
  const currentConnection = get(getNetworkCondition(), ['effectiveType'], TYPE_3G);
  const currentRating = NETWORK_EFFECTIVE_TYPE_RATING[currentConnection];
  return currentRating === NETWORK_EFFECTIVE_TYPE_RATING[TYPE_4G];
};

// 3g and 4g
export const isOKConnection = (): boolean => {
  const currentConnection = get(getNetworkCondition(), ['effectiveType'], TYPE_3G);
  const currentRating = NETWORK_EFFECTIVE_TYPE_RATING[currentConnection];
  return currentRating > NETWORK_EFFECTIVE_TYPE_RATING[TYPE_2G];
};

export const isDataSavingMode = (): boolean => get(getNetworkCondition(), ['saveData'], false);
